import {format as formatSQL} from 'sql-formatter';

import {assertAndContinue} from 'Asserts';

export default function tryFormatSQLQuery(sql: string): string {
  const paramRegex = String.raw`\{\{.+?\}\}`;

  try {
    return formatSQL(sql, {
      language: 'postgresql',
      paramTypes: {custom: [{regex: paramRegex}]},
    });
    // eslint-disable-next-line benchlint/always-throw-from-catch
  } catch (err) {
    assertAndContinue(false, 'Failed to format SQL query', {err, sqlQuery: sql});
    return sql;
  }
}
